function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.44653 1.70762C6.62153 1.17038 7.38161 1.17038 7.55603 1.70762L8.44211 4.43412C8.48024 4.55108 8.55437 4.65298 8.6539 4.72527C8.75343 4.79756 8.87326 4.83653 8.99628 4.83663H11.8634C12.4286 4.83663 12.6631 5.55996 12.2064 5.89246L9.88703 7.57713C9.7874 7.64955 9.71325 7.75166 9.67521 7.86881C9.63718 7.98596 9.6372 8.11215 9.67528 8.22929L10.5608 10.9558C10.7358 11.4936 10.1204 11.9405 9.66361 11.608L7.34428 9.92329C7.24459 9.85083 7.12452 9.81179 7.00128 9.81179C6.87804 9.81179 6.75796 9.85083 6.65828 9.92329L4.33894 11.608C3.88219 11.9405 3.26678 11.493 3.44178 10.9558L4.32728 8.22929C4.36536 8.11215 4.36538 7.98596 4.32734 7.86881C4.2893 7.75166 4.21516 7.64955 4.11553 7.57713L1.79619 5.89246C1.33886 5.55996 1.57453 4.83663 2.13919 4.83663H5.00569C5.1288 4.83666 5.24877 4.79774 5.34842 4.72544C5.44806 4.65314 5.52228 4.55117 5.56044 4.43412L6.44653 1.70762Z",
  stroke: "#B45309",
  strokeWidth: 1.16667
});

function SvgTeamPremium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamPremium);
export default __webpack_public_path__ + "static/media/team-premium.6641e265.svg";
export { ForwardRef as ReactComponent };